{
    AOS.init({ duration: 300 });
}

{
    document.addEventListener("DOMContentLoaded", function () {
        const allAccordions = document.querySelectorAll(".accordion-item");

        const groups = new Map();

        allAccordions.forEach((item) => {
            const header = item.querySelector(".accordion-item-header");
            const body = item.querySelector(".accordion-item-body");
            if (!header || !body) return;

            const parent = item.parentElement;
            if (!groups.has(parent)) {
                groups.set(parent, true);
                header.classList.add("active");
                body.style.maxHeight = body.scrollHeight + "px";
            } else {
                body.style.maxHeight = "0px";
            }

            header.addEventListener("click", function () {
                const isActive = header.classList.contains("active");

                parent.querySelectorAll(".accordion-item-header").forEach((h) => {
                    h.classList.remove("active");
                    const b = h.nextElementSibling;
                    if (b) b.style.maxHeight = "0px";
                });

                if (!isActive) {
                    header.classList.add("active");
                    body.style.maxHeight = body.scrollHeight + "px";
                }
            });
        });

        window.addEventListener("resize", () => {
            document.querySelectorAll(".accordion-item-header.active").forEach((header) => {
                const body = header.nextElementSibling;
                if (body) body.style.maxHeight = body.scrollHeight + "px";
            });
        });
    });
}

{
    document.addEventListener("DOMContentLoaded", () => {
        const tabButtons = document.querySelectorAll(".faq-tab-btn");
        const accordionItems = document.querySelectorAll(".accordion-item");

        tabButtons.forEach((btn) => {
            btn.addEventListener("click", () => {
                const targetId = btn.getAttribute("data-tab-id");

                tabButtons.forEach((tab) => tab.classList.remove("active"));

                btn.classList.add("active");

                accordionItems.forEach((item) => {
                    if (item.getAttribute("data-accordion-id") === targetId) {
                        item.style.display = "block";
                    } else {
                        item.style.display = "none";
                    }
                });
            });
        });

        if (tabButtons.length > 0) {
            tabButtons[0].click();
        }
    });
}

{
    document.addEventListener('DOMContentLoaded', () => {
        const tabs = document.querySelectorAll('.tabProd');
        const contents = document.querySelectorAll('.tab-prod-content');
        tabs[0].classList.add('active-tab');
        contents[0].classList.add('active-content');

        tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => {
                tabs.forEach(t => t.classList.remove('active-tab'));
                contents.forEach(c => c.classList.remove('active-content'));

                tab.classList.add('active-tab');
                contents[index].classList.add('active-content');
            });
        });
    });
}

{
    document.addEventListener('DOMContentLoaded', () => {
        let reviewBoxes = document.querySelectorAll('.testBoxesRow .testBox');
        let loadReviewBtn = document.querySelector('.loadMoreReviews .ReviewsBtn');
        let spinner = document.querySelector('.load-more_spinner');
        let visibleCount = 9;
        console.log('Total Boxes : ', reviewBoxes.length)

        reviewBoxes.forEach((box, index) => {
            box.style.display = index < visibleCount ? 'block' : 'none';
        });

        loadReviewBtn.addEventListener('click', () => {
            loadReviewBtn.style.display = 'none';
            spinner.style.display = 'block';

            setTimeout(() => {
                for (let i = visibleCount; i < visibleCount + 3; i++) {
                    if (reviewBoxes[i]) reviewBoxes[i].style.display = 'block';
                }
                visibleCount += 3;

                if (visibleCount >= reviewBoxes.length) {
                    loadReviewBtn.parentElement.style.display = 'none';
                } else {
                    loadReviewBtn.style.display = 'inline-block';
                    spinner.style.display = 'none';
                }
            }, 600);
        });
    });
}
// BLOG PAGE 
{
    
    let currentIndex = 12; // Initially show 12 articles
    let articles = document.querySelectorAll('.mainBlogPageBlogHldr .blog-articles__article'); // Get all articles
    const loadMoreButton = document.querySelector('.mainBlogPageBlogHldr .load-more_btn');
    const loadMoreSpinner = document.querySelector('.mainBlogPageBlogHldr .load-more_spinner');
    const totalArticles = articles.length;

    function loadMoreArticles() {
        loadMoreSpinner.style.display = 'inline-block';
        loadMoreButton.style.display = 'none';

        setTimeout(() => {
            let nextIndex = currentIndex + 6;
            for (let i = currentIndex; i < nextIndex && i < totalArticles; i++) {
            articles[i].style.display = 'block';
            }
            currentIndex = nextIndex;

            if (currentIndex >= totalArticles) {
            loadMoreButton.style.display = 'none';
            } else {
            loadMoreButton.style.display = 'inline-block';
            }
            loadMoreSpinner.style.display = 'none';
        }, 1000);
    }

    for (let i = 12; i < totalArticles; i++) {
        articles[i].style.display = 'none';
    }

}
// BLOG PAGE - SCRIPT END

{
    document.addEventListener("DOMContentLoaded", function () {
        const contentBoxes = document.querySelectorAll(".testBoxContentRow");

        contentBoxes.forEach(function (contentBox) {
            const para = contentBox.querySelector("p");
            requestAnimationFrame(() => {
                const isClamped = para.scrollHeight > para.clientHeight;
                if (isClamped) {
                    const toggleBtn = document.createElement("span");
                    toggleBtn.className = "read-toggle";
                    toggleBtn.textContent = "Read More";

                    contentBox.appendChild(toggleBtn);

                    toggleBtn.addEventListener("click", function () {
                        contentBox.classList.toggle("expanded");
                        toggleBtn.textContent = contentBox.classList.contains("expanded")
                            ? "Read Less"
                            : "Read More";
                    });
                }
            });
        });
    });
}

{
    document.addEventListener("DOMContentLoaded", function () {
        document.querySelectorAll(".locationBoxPopup").forEach(popup => {
            const popupClose = popup.querySelector(".popup-close");
            const popupNumber = popup.querySelector(".popup-number h3");
            const qrImage = popup.querySelector("img");

            const phoneLink = popup.closest("body").querySelector(
                `[data-popup-id="${popup.id}"]`
            );

            const relatedPhone = phoneLink || popup.parentElement.querySelector('a[href^="tel:"]');

            if (!relatedPhone) return;

            relatedPhone.addEventListener("click", function (event) {
                if (window.innerWidth <= 575) return;
                if (!qrImage || !qrImage.getAttribute("src")) return;

                event.preventDefault();
                if (popupNumber) popupNumber.textContent = this.textContent.trim();
                popup.classList.add("active");
            });

            popupClose?.addEventListener("click", () => popup.classList.remove("active"));
            popup.addEventListener("click", (e) => {
                if (e.target === popup) popup.classList.remove("active");
            });

            window.addEventListener("resize", () => {
                if (window.innerWidth <= 575) popup.classList.remove("active");
            });
        });
    });
}

{
  document.addEventListener('DOMContentLoaded', () => {
    const popup = document.getElementById("popup");
    const closeBtns = document.querySelectorAll(".closePopup");
    const openBtn = document.querySelector(".poupupBtnOpener");
    const today = new Date().toISOString().split('T')[0];
    const lastShownDate = localStorage.getItem("popupLastShownDate");

    if (lastShownDate !== today) {
      setTimeout(() => {
        popup.style.display = "flex";
        popup.classList.add("visible");
        localStorage.setItem("popupLastShownDate", today);
      }, 3000); 
    }

    closeBtns.forEach(btn => {
        btn.addEventListener('click', () =>{
            popup.classList.remove("visible");
            popup.style.display = "none";
        })
    });

    openBtn?.addEventListener("click", () => {
      popup.style.display = "flex";
      setTimeout(() => popup.classList.add("visible"), 30);
    });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  const accountBtns = document.querySelectorAll(".header__icon--account");
  const dropdowns = document.querySelectorAll(".account-dropdown");
  accountBtns.forEach((btn, index) => {
    btn.addEventListener("click", (e) => {
      e.stopPropagation(); 
      const dropdown = dropdowns[index];
      if (dropdown.classList.contains("active")) {
        dropdown.classList.remove("active");
      } else {
        dropdowns.forEach(drop => drop.classList.remove("active"));
        dropdown.classList.add("active");
      }
    });
  });
  document.addEventListener("click", (e) => {
    let clickedInside = false;
    accountBtns.forEach((btn, index) => {
      const dropdown = dropdowns[index];
      if (btn.contains(e.target) || dropdown.contains(e.target)) {
        clickedInside = true;
      }
    });
    if (!clickedInside) {
      dropdowns.forEach(drop => drop.classList.remove("active"));
    }
  });
});

// {
//     document.addEventListener('DOMContentLoaded', () => {
//         if (window.innerWidth >= 1025) {
//             gsap.registerPlugin(ScrollTrigger);

//             const section = document.querySelector(".videoSect");
//             section.style.height = window.innerHeight + "px";

//             gsap.to(".videoCntntRow", {
//                 y: "0%",
//                 ease: "none",
//                 scrollTrigger: {
//                     trigger: section,
//                     start: "top top",
//                     end: () => "+=" + window.innerHeight,
//                     pin: true,
//                     pinSpacing: true,
//                     scrub: true,
//                     anticipatePin: 1,
//                     invalidateOnRefresh: true,
//                     markers: false
//                 }
//             });

//             window.addEventListener("resize", () => {
//                 section.style.height = window.innerHeight + "px";
//                 ScrollTrigger.refresh();
//             });
//         }
//     });
// }

// document.addEventListener('DOMContentLoaded', () => {
//     // 1025px se upar ke liye logic
//     if (window.innerWidth >= 1025) {
//         gsap.registerPlugin(ScrollTrigger);

//         const section = document.querySelector(".videoSect");
//         const videoRow = document.querySelector(".videoCntntRow");

//         // Section height aur margin reset taake top space na aaye
//         gsap.set(section, { height: "100vh", marginTop: 0, paddingTop: 0 });

//         // ScrollTrigger setup
//         const tl = gsap.to(videoRow, {
//             y: "0%",
//             ease: "none",
//             scrollTrigger: {
//                 trigger: section,
//                 start: "top top", // Section ka top screen ke top se milega
//                 end: () => "+=" + window.innerHeight,
//                 pin: true,
//                 pinSpacing: true, // Space ko maintain rakhega bina extra gap ke
//                 scrub: 1, // Thora smooth scroll 
//                 anticipatePin: 1,
//                 invalidateOnRefresh: true,
//                 onRefresh: self => {
//                     // Refresh par top alignment check karne ke liye
//                     if(self.progress === 0) {
//                         gsap.set(videoRow, {clearProps: "all"});
//                     }
//                 }
//             }
//         });

//         // Resize handler with debounce taake jump na kare
//         let resizeTimeout;
//         window.addEventListener("resize", () => {
//             clearTimeout(resizeTimeout);
//             resizeTimeout = setTimeout(() => {
//                 section.style.height = window.innerHeight + "px";
//                 ScrollTrigger.refresh();
//             }, 200);
//         });
//     }
// });
document.addEventListener('DOMContentLoaded', () => {
    // Media Query check for Desktop
    const mm = gsap.matchMedia();

    mm.add("(min-width: 1025px)", () => {
        gsap.registerPlugin(ScrollTrigger);

        const section = document.querySelector(".videoSect");
        const videoRow = document.querySelector(".videoCntntRow");

        // Force browser to stop its own smooth scroll logic
        gsap.set("html", { scrollBehavior: "auto" });

        const tl = gsap.to(videoRow, {
            y: "0%",
            ease: "none",
            scrollTrigger: {
                trigger: section,
                start: "top top",
                end: () => "+=" + window.innerHeight,
                pin: true,
                pinSpacing: true,
                scrub: 1,
                // Browser compatibility settings
                anticipatePin: 1,
                fastScrollEnd: true, // Tezi se scroll karne par glitch nahi dega
                invalidateOnRefresh: true, 
                refreshPriority: 1 // Baaqi triggers se pehle isay calculate karega
            }
        });

        // Resize handler with a small delay for mobile/safari stability
        window.addEventListener("resize", () => {
            ScrollTrigger.refresh();
        });

        return () => { 
            // Cleanup jab screen choti ho jaye
            tl.kill();
        };
    });
});
// {
//     document.addEventListener("DOMContentLoaded", function () {
//         const btn = document.querySelector(".TopScroll");
//         window.addEventListener("scroll", function () {
//             if (window.scrollY > 300) {
//                 btn.classList.add("show");
//             } else {
//                 btn.classList.remove("show");
//             }
//         });

//         btn.addEventListener("click", function (e) {
//             e.preventDefault();
//             window.scrollTo({
//                 top: 0,
//                 behavior: "smooth",
//             });
//         });
//     });
// }

